import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import SocialSharing from 'vue-social-sharing'
import vueHeadful from 'vue-headful'
import i18n from './i18n'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMatomo from 'vue-matomo'
require('@/assets/main.sass');
import AOS from "aos"

Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://stats.blackdigital.fr',
  siteId: 5,
  router: router
});

library.add([faEnvelope, faFacebook, faTwitter])

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('vue-headful', vueHeadful);
Vue.use(SocialSharing);

Vue.use(VueRouter)
Vue.config.productionTip = false

Vue.use(
  AOS.init({
    duration: 800,
    delay: 0,
    once: true,
    offset: 200,
    startEvent: 'load'
  })
);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
